export const fetch = async (
  url: string,
  options?: RequestInit,
  timeout = 5000
): Promise<Response> =>
  Promise.race<Response>([
    new Promise<Response>((_, reject) => setTimeout(reject, timeout)),
    globalThis.fetch(url, options),
  ]);
